import { useRef } from "react";
import { Oferta } from "../types/landingSections";
import LandingCard from "../reutilizableLanding/LandingCard";

type CarouselBlockProps = {
  items: Oferta[];
  styles?: any;
};

const CarouselBlock: React.FC<CarouselBlockProps> = ({ items, styles }) => {
  const getImages = (o: Oferta) =>
    Array.isArray(o.imagenes) ? o.imagenes.filter(Boolean) : [];

  const containerRef = useRef<HTMLDivElement>(null);

  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!containerRef.current) return;

    isDragging.current = true;
    startX.current = e.pageX;
    scrollLeft.current = containerRef.current.scrollLeft;

    containerRef.current.style.cursor = "grabbing";
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDragging.current || !containerRef.current) return;

    e.preventDefault();

    const walk = (e.pageX - startX.current) * 1.5;

    containerRef.current.scrollLeft = scrollLeft.current - walk;
  };

  const stopDragging = () => {
    isDragging.current = false;

    if (containerRef.current) {
      containerRef.current.style.cursor = "grab";
    }
  };

  return (
    <section className="w-full overflow-hidden">
      <div
        ref={containerRef}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={stopDragging}
        onMouseLeave={stopDragging}
        className="
        relative
        z-10
      
        grid
        grid-flow-col
        auto-cols-[160px]
        sm:auto-cols-[170px]
        lg:auto-cols-[180px]
      
        gap-5
      
        overflow-x-auto
        overflow-y-visible
      
        scroll-smooth
        snap-x
        snap-mandatory
      
        px-3
        py-4

        touch-pan-x
        overscroll-x-contain
        scrollbar-hidden
        cursor-grab
        select-none
      "
      >
        {items.map((o) => (
          <div key={o.id} className="snap-start">
            <LandingCard
              titulo={o.titulo}
              descripcion={o.descripcion}
              precio={o.precio ?? 0}
              imagenes={getImages(o)}
              styles={styles}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default CarouselBlock;
